import useOffers from 'hooks/Offers/useOffers'
import { FullTrip } from 'tripPlanner/types/common'
import {
  AccommodationItem,
  TourItem,
} from 'tripPlanner/types/tripItem'

export function useTripIncludesFlashOffer(trip: FullTrip) {
  const leOfferIds = trip.items
    .filter(
      (item): item is AccommodationItem | TourItem =>
        item.sourceType === 'LE_Hotel' || item.sourceType === 'LE_Tour',
    )
    .map((item) => item.code)
    .filter((offerId): offerId is string => !!offerId)

  const [offers] = useOffers(leOfferIds)

  return offers.some(
    (offer) => offer?.type === 'hotel' || offer?.type === 'tour',
  )
}
